import templateGet from './get/template.html';
import controllerGet from './get';

const formsState = {
  url: '/forms',
  stateName: 'Company Forms',
  data: {
    specialClass: 'fixed-sidebar'
  },
  views: {
    'a@app': {
      template: templateGet,
      controller: controllerGet,
      controllerAs: 'formsCtrl'
    }
  },
  resolve: {
    ResolveClass: 'ResolveClass',
    authenticateCompany: /* @ngInject */ ResolveClass => ResolveClass.authenticateCompany('/forms'),
    refresh: /* @ngInject */ ResolveClass => {
      return ResolveClass.refreshLogin(true, 'admin.forms');
    }
  }
};

export { formsState };



// WEBPACK FOOTER //
// ./src/app/controllers/users/forms/index.js